export interface DeleteSystemUserLinkRequest {
  id: string
  revision: number
}

export function DeleteSystemUserLinkRequestToJSON(
  value: DeleteSystemUserLinkRequest
): any {
  return {
    id: value.id !== '' ? value.id : '',
    revision: value.revision !== 0 ? value.revision : 0
  }
}
